export function hasDefaultStripeCard(
  contact?: {
    stripe_default_payment_method_id?: string | null;
  } | null
) {
  return Boolean(contact?.stripe_default_payment_method_id);
}

export function getAutoChargeDefaults(hasDefaultCard: boolean) {
  return {
    auto_charge_enabled: hasDefaultCard,
    auto_charge_status: hasDefaultCard ? 'pending' : null,
    auto_charge_attempts: 0,
  };
}
